"use client";
import dynamic from "next/dynamic";
import Hero from "@/components/prebook Customer/Hero";
import TheProblem from "@/components/prebook Customer/TheProblem";
import HowItWorks from "@/components/prebook Customer/HowItWorks";

const PartnerPlans = dynamic(() => import("@/components/prebook Customer/PartnerPlans"));
const EarningsCalculator = dynamic(() => import("@/components/prebook Customer/EarningsCalculator"));
const TheOpportunity = dynamic(() => import("@/components/prebook Customer/TheOpportunity"));
const PreBookNow = dynamic(() => import("@/components/prebook Customer/PreBookNow"));
const FAQ = dynamic(() => import("@/components/prebook Customer/FAQ"));

const page = () => {
  return (
    <>
      <Hero />
      {/* <TheProblem /> */}
      {/* <HowItWorks /> */}
      {/* <PartnerPlans /> */}
      <PreBookNow />
      {/* <EarningsCalculator /> */}
      {/* <TheOpportunity /> */}
      {/* <FAQ /> */}
    </>
  );
};

export default page;
